import css from 'styled-jsx/css';

const styles = css.global`.modal-installments {
  padding: calc(40px - 24px) 0;
}

.modal-installments .text-title {
  color: #222;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  margin: 0 0 32px;
}

.modal-installments .info-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 4px;
  background: #f5f9fb;
  gap: 8px;
  min-height: 130px;
  margin: 32px 0 80px;
}

.modal-installments .info-box .text-desc {
  color: #222;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
  max-width: 128px;
}

.modal-installments .sn-button.white {
  margin-top: 16px;
}

.modal-installments .text-title-desk {
  display: none;
}

@media (min-width: 992px) {
  .modal-installments {
    padding: 0;
    height: 100%;
  }

  .modal-installments .text-title-desk {
    display: block;
    max-width: calc(100% - 48px);
    color: #222;
    margin: 0;
    font-family: SantanderHeadline;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0%;
  }

  .modal-installments .text-title {
    margin: 22px 0 46px;
  }

  .modal-installments .ctn-home-24 {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .modal-installments .btn-wrapper {
    display: block;
    margin-top: auto;
  }

  .modal-installments .info-box .text-desc {
    max-width: 224px;
  }

  .modal-installments .sn-button.white {
    display: none !important;
  }
}
`;

export default styles;